module.exports = __webpack_public_path__ + "static/paris-022-6c0cf972960cdf8622ce8079e26f025a.jpg";